import axios from "axios";
import get from "lodash/get";
import * as Sentry from "@sentry/browser";
import config from "@/config";
import storage from "../storage";
import device from "../device";

const request = axios.create({
  baseURL: config.API_ROOT,
});

request.defaults.params = {};
request.defaults.params["_f"] = "json";
request.defaults.headers.common["Accept"] = "application/json";
request.defaults.headers.common["Cache-Control"] = "no-cache";

const deviceInfo = {
  device_id: device.getDeviceId(),
  device_name: null,
  location: null,
  app: "admin",
};

const setDeviceInfo = (overrides) => {
  Object.assign(deviceInfo, overrides);
  // request.defaults.params["device_info"] = JSON.stringify(deviceInfo);
};

setDeviceInfo({});
device.getDeviceName().then((device_name) => setDeviceInfo({ device_name }));
device.subscribeLocation((location) => setDeviceInfo({ location }));
// Only resumes tracking if permission was already granted earlier - never
// triggers a native prompt on its own.
device.trackLocationIfAllowed();

let store = null;

const subscribe = (appStore) => {
  store = appStore;
  const state = store.getState();
  request.defaults.params["_l"] = state.system.currentLangCode;
  request.defaults.params["_c"] = state.system.currentCountryCode;
};

const BODY_DEVICE_INFO_METHODS = ["post", "put", "patch", "delete"];

request.interceptors.request.use((requestConfig) => {
  const state = store && store.getState();
  const token = get(state, "auth.token") || storage.get("token");

  if (token) {
    requestConfig.headers.set("Authorization", `Bearer ${token}`);
  }

  const method = (requestConfig.method || "").toLowerCase();

  if (
    BODY_DEVICE_INFO_METHODS.includes(method) &&
    requestConfig.params &&
    requestConfig.params.device_info
  ) {
    const { device_info, ...restParams } = requestConfig.params;
    requestConfig.params = restParams;

    if (requestConfig.data instanceof FormData) {
      // Multipart fields can only hold strings, so this one stays JSON-encoded.
      requestConfig.data.set("device_info", device_info);
    } else {
      // Plain JSON body - send device_info as a real nested object, not a
      // double-encoded string, since axios JSON-serializes the whole body anyway.
      requestConfig.data = {
        ...(requestConfig.data || {}),
        device_info: deviceInfo,
      };
    }
  }

  return requestConfig;
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedError) {
      Sentry.withScope((scope) => {
        scope.setExtra("Error URL", get(error, "config.url"));
        scope.setExtra("Error Message", get(error, "response.data.message"));
        scope.setExtra(
          "Error Status",
          `${get(error, "response.status")} - ${get(
            error,
            "response.statusText",
          )}`,
        );
        scope.setExtra("Error Full", error);
        Sentry.captureException(error);
      });
    }

    return Promise.reject(error);
  },
);

export default {
  request,
  subscribe,
};
